import React from 'react';
import ModalWrapper from '../../elements/ModalWrapper';
import { Divider, Group, LoadingOverlay, Stack, Text } from '@mantine/core';
import Button from '../../elements/Button';
import { FiChevronLeft } from 'react-icons/fi';
import { useFullscreen } from '@mantine/hooks';
import { HiOutlineArrowsExpand, HiOutlineDownload, HiX } from 'react-icons/hi';
import Badge from '../../elements/Badge';

interface ModalChartTrainingProps {
  title: string;
  bandName?: string;
  description?: any;
  loading: boolean;
  downloadable?: boolean;
  loadingDownload?: boolean;
  onDownload?: () => void;
  backButton?: boolean;
  isVisible: boolean;
  onClose: () => void;
  onBack?: () => void;
  chart: React.ReactNode;
}

const ModalChart: React.FC<ModalChartTrainingProps> = ({
  backButton,
  loadingDownload,
  downloadable,
  onDownload,
  isVisible,
  description,
  onClose,
  onBack,
  loading,
  title,
  bandName,
  chart
}) => {
  const { ref, toggle, fullscreen } = useFullscreen();
  return (
    <ModalWrapper
      isVisible={isVisible}
      onClose={onClose}
      title={title}
      withCloseButton
      size="calc(100vw - 3rem)"
    >
      {bandName && <Badge variant="light">{bandName}</Badge>}
      <Divider my={16} />
      <Group
        justify={downloadable ? 'space-between' : 'flex-start'}
        align="flex-start"
        mb={16}
      >
        {/* <Text my={16} fz={18}>
          {description === 'undefined' ? '' : description}
        </Text> */}

        {description && (
          <>
            <Group flex={1}>{description}</Group>
          </>
        )}
        {downloadable && (
          <Button
            type="button"
            variant="outline"
            leftSection={<HiOutlineDownload />}
            onClick={onDownload}
          >
            Download Data Filter
          </Button>
        )}
      </Group>
      <Stack ref={ref} bg={'white'} p={fullscreen ? 16 : 0}>
        <Group justify={backButton ? 'space-between' : 'flex-end'}>
          {backButton && (
            <>
              <Button
                leftSection={<FiChevronLeft />}
                onClick={onBack}
                variant="outline"
                styles={{
                  minHeight: 'unset',
                  padding: '4px 8px',
                  borderColor: '#CCCCCC',
                  color: '#333333',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12
                }}
              >
                Previous Chart
              </Button>
            </>
          )}

          <Button
            leftSection={fullscreen ? <HiX /> : <HiOutlineArrowsExpand />}
            onClick={() => toggle()}
            variant="outline"
            styles={{
              minHeight: 'unset',
              padding: '4px 8px',
              borderColor: fullscreen ? '#D1211A' : '#CCCCCC',
              color: fullscreen ? 'white' : '#333333',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 12,
              backgroundColor: fullscreen ? '#D1211A' : 'transparent'
            }}
          >
            {fullscreen ? 'Exit' : 'Open'} Fullscreen
          </Button>
        </Group>
        {chart}
      </Stack>
      <LoadingOverlay visible={loading || loadingDownload} />
    </ModalWrapper>
  );
};

export default ModalChart;
